import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import api from '../api';

const field: React.CSSProperties = {
  width: '100%',
  padding: '10px',
  fontSize: '16px',
  border: '1px solid #ccc',
  borderRadius: '4px',
  boxSizing: 'border-box',
};

export default function Register() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState<'advisor' | 'admin'>('advisor');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.post('/api/auth/register', { name, email, password, role });
      // Auto-login after successful registration.
      const { data } = await api.post('/api/auth/login', { email, password });
      login(data.token, data.user);
      navigate(data.user.role === 'admin' ? '/admin' : '/app', { replace: true });
    } catch (err) {
      setError(
        axios.isAxiosError(err)
          ? err.response?.data?.error || 'Registration failed.'
          : 'An unexpected error occurred.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '40px 20px', maxWidth: '420px', margin: '60px auto', fontFamily: 'Arial' }}>
      <h1 style={{ textAlign: 'center', marginBottom: '6px' }}>Create Account</h1>
      <p style={{ textAlign: 'center', color: '#666', marginBottom: '28px' }}>Join Financial Roleplay Training</p>

      <div style={{ border: '1px solid #ccc', padding: '30px', borderRadius: '8px' }}>
        <form onSubmit={handleSubmit}>
          {error && (
            <div style={{ background: '#ffebee', color: '#c62828', padding: '10px 14px', borderRadius: '4px', marginBottom: '16px', fontSize: '14px' }}>
              {error}
            </div>
          )}

          <div style={{ marginBottom: '15px' }}>
            <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Full Name</label>
            <input
              type="text" value={name} onChange={e => setName(e.target.value)}
              required minLength={2} autoFocus style={field} placeholder="Your full name"
            />
          </div>

          <div style={{ marginBottom: '15px' }}>
            <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Email</label>
            <input
              type="email" value={email} onChange={e => setEmail(e.target.value)}
              required style={field} placeholder="you@example.com"
            />
          </div>

          <div style={{ marginBottom: '15px' }}>
            <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Password</label>
            <input
              type="password" value={password} onChange={e => setPassword(e.target.value)}
              required minLength={8} style={field} placeholder="Min. 8 characters"
            />
          </div>

          <div style={{ marginBottom: '22px' }}>
            <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Role</label>
            <select
              value={role} onChange={e => setRole(e.target.value as 'advisor' | 'admin')}
              style={{ ...field, background: 'white' }}
            >
              <option value="advisor">Advisor</option>
              <option value="admin">Admin</option>
            </select>
          </div>

          <button
            type="submit" disabled={loading}
            style={{ width: '100%', padding: '12px', fontSize: '16px', backgroundColor: '#4CAF50', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
          >
            {loading ? 'Creating account…' : 'Create Account'}
          </button>
        </form>

        <div style={{ marginTop: '20px', textAlign: 'center', fontSize: '14px', color: '#555' }}>
          Already have an account?{' '}
          <Link to="/login" style={{ color: '#2196F3', textDecoration: 'none' }}>Sign in</Link>
        </div>
      </div>
    </div>
  );
}
